import React from 'react';
import { Card, CardBody } from 'reactstrap';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import ReactTable from 'react-table';
import DataTablePagination from '../../../../../../components/DatatablePagination';

const ItemClickStats = ({ labels, data }) => {
    return (
        <Card>
            <div style={{ padding: '15px' }}>
                <div className="float-left float-none-xs">
                    <div className="d-inline-block">
                        <h5 className="d-inline"><IntlMessages id="dashboards.messenger-stats" /></h5>
                        <span className="text-muted text-small d-block">
                            <IntlMessages id="dashboards.messenger-stats-topic-view" />
                        </span>
                    </div>
                </div>
            </div>
            <CardBody>
                <ReactTable
                    data={data}
                    columns={labels}
                    defaultPageSize={5}
                    filterable={false}
                    showPageJump={true}
                    PaginationComponent={DataTablePagination}
                    showPageSizeOptions={true}
                    defaultSorted={[
                        {
                            id: 'clicks',
                            desc: true,
                        },
                    ]}
                />
            </CardBody>
        </Card>
    );
};

export default ItemClickStats;
